class ProjectListComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('projects-loaded', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('customer-logged-out', async () => this.onLogout(), true)
    document.addEventListener('customer-logged-in-and-upgraded', async () => this.onLoggedInAndUpgraded(), true)
    document.addEventListener('customer-logged-in-not-upgraded', async () => this.onLoggedInNotUpgraded(), true)
  }

  async onLogout() {
    document.getElementById('upgrade-list-item').classList.remove('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('saved-projects-list-header').classList.add('d-none')
    document.getElementById('project-list').innerHTML = ''
    document.getElementById('project-list').classList.add('d-none')
  }

  async onLoggedInAndUpgraded() {
    document.getElementById('upgrade-list-item').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('saved-projects-list-header').classList.remove('d-none')
    document.getElementById('project-list').classList.remove('d-none')
    document.getElementById('project-list').innerHTML = String.raw`
      <li>
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </li>
      `
  }

  async onLoggedInNotUpgraded() {
    document.getElementById('upgrade-list-item').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.remove('d-none')
    document.getElementById('saved-projects-list-header').classList.add('d-none')
    document.getElementById('project-list').innerHTML = ''
    document.getElementById('project-list').classList.add('d-none')
  }

  async onUpdate(projects) {
    let str = ''
    projects.forEach( (project) => {
      str += String.raw`
        <li><a href="#" id="project-${project.key}" class="link-dark rounded ${project.isActive ? 'fw-bold' : ''}">
          <div>
            ${project.title}
            <br>
            <small>${project.boltAndNut.boltDiameterLabel} ${project.boltAndNut.boltTypeStr}</small>
            <br>
            <small>${project.boltAndNut.nutStudOrHookStr}</small>
          </div>
        </a></li>`
    })

    document.getElementById('project-list').innerHTML = str

    projects.forEach((project) => {
      document.getElementById(`project-${project.key}`).onclick = async () => {
        let event = new CustomEvent('load-project', { detail: project });
        document.dispatchEvent(event)
      }
    })
  }

  connectedCallback() {
    this.innerHTML = String.raw`
          <div class="d-flex flex-column align-items-stretch flex-shrink-0" style="width: 240px; ">

            <div class="list-group" style="margin-top:10px;">
              <a href="#" class="list-group-item" id="project-list-new-design">
                <div class="text-success">
                  <b>New Anchor Bolt Design</b>
                  <i class="fa fa-fw fa-file-o pull-right"></i>
                </div>
              </a>
            </div>
          
            <!--<div class="list-group" style="margin-top:10px">
              <div id="current-project-item" class="list-group-item">
                <strong><span id="active-project-title">
                    Untitled Anchor Bolt Design
                  </span></strong>
                <div>
                  <strong><small>
                      <span id="active-project-shape">ACI Appendix D</span>
                      <span id="active-project-design-spec">Anchorage to Concrete</span>
                    </small></strong>
                </div>
                <div class="text-muted small"><em><span id="active-project-timeago"></span></em></div>
              </div>
            </div>-->
          
            <div class="list-group d-none" id="upgrade-list-item" style="margin-top:10px">
              <a href="#" class="list-group-item" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
                <h4 class="text-success">
                  <strong>Print</strong> and <strong>Save</strong> projects
                </h4>
                <p class="text-success">
                  Upgrade for $19 monthly
                </p>
                <a href="#" class="btn btn-lg btn-success btn-block" data-bs-toggle="modal" 
                data-bs-target="#modal-sign-up-form" >Upgrade</a>
              </a>
            </div>
          
            <div class="list-group d-none" id="finish-upgrade-list-item" style="margin-top:10px">
              <a href="#" class="btn btn-lg btn-success btn-block" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">Start
                Subscription</a>
            </div>
          
            <div class="list-group" id="saved-projects-list-header" style="margin-top:10px">
              <div class="list-group-item">Saved Projects</div>
            </div>

            <div class="list-group list-group-flush border-bottom scrollarea">
              <div class="list-group-item">
                <ul class="list-unstyled ps-0">
                  <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small" id="project-list">
                  </ul>
                  <!--<li class="mb-1">
                    <button class="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse"
                      data-bs-target="#home-collapse" aria-expanded="true">
                      Emmie Project
                    </button>
                    <div class="collapse show" id="home-collapse">
                      <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                        <li><a href="#" class="link-dark rounded">Header 1</a></li>
                        <li><a href="#" class="link-dark rounded">Steel Support</a></li>
                        <li><a href="#" class="link-dark rounded">Roof Beam Header</a></li>
                      </ul>
                    </div>
                  </li>-->
                </ul>
              </div>
            </div>
          </div>
      `
  }
}

customElements.define('project-list-component', ProjectListComponent);